import React from "react";

import clsx from "clsx";

import { Container } from "@busbud/horizon";

import { FooterItem } from "./common/footer-item";

interface Props {
  className?: string;
  baseClassName?: string;
  noDivider?: boolean;
  children: React.ReactNode;
}

const FooterDivider = () => <FooterItem />;

export const FooterMainSection: React.FC<Props> = ({
  className,
  children,
  noDivider = false
}) => {
  const with_divider = !noDivider;
  return (
    <Container className={clsx("sm:pb-800 sm:pt-600 md:pt-800", className)}>
      <div className="flex flex-col sm:gap-200">
        {!!with_divider && <FooterDivider />}
        <div className="flex flex-col sm:flex-row sm:gap-200">{children}</div>
      </div>
    </Container>
  );
};
